export const LEVERAGE_OPTIONS = [100, 200, 300, 400, 500, 1000, 5000];
// export const LEVERAGE_OPTIONS = [1, 2, 3, 5, 10, 15, 20, 25, 33, 40, 50, 66, 75, 80, 100, 125, 150, 175, 200, 300, 400, 500, 1000, 5000];
